import React from 'react';
import { useSelector } from 'react-redux';
import history from '../../../../../../shared/history';
import { PurchasePhoneNumberIcon } from '../../../../../../shared/svg/purchase-phone-number-icon';
import { PlayIcon } from '../../../../../../shared/svg/play-icon';
import hasPermission from '../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../shared/utils/access-control/enums/permissions';
import { contactAdmin } from '../../../../../../shared/utils/contact-admin';
import { RootState } from '../../../../../../store/root-reducer';
import { supportUrls } from '../../../../../../shared/utils/urls';
import { AnalyticsEvents } from '../../../../../../shared/enums/analytics';
import {
  getUserShAccountId,
  getUserTrackingId,
} from '../../../../../../shared/utils/user-details';
// import './_purchase-phone-number-banner.scss';

const PurchasePhoneNumberBanner = () => {
  const canPurchase = hasPermission(Permissions.PHONE_NUMBER_PURCHASE_READ);

  const { firstName, lastName, adminDetails } = useSelector(
    (state: RootState) => state.home,
  );

  const handlePurchaseClick = () => {
    window.analytics?.track?.({
      userId: getUserTrackingId(),
      event: AnalyticsEvents.DialerNumberPurchaseFlowStarted,
      properties: {
        shAccountId: getUserShAccountId(),
      },
    });
    history.push('/dialer/phone-numbers/purchase');
  };

  const handleContactOwner = () => {
    const ownerName = [adminDetails?.firstName, adminDetails?.lastName]
      .filter(Boolean)
      .join(' ');
    const requesterName = [firstName, lastName].filter(Boolean).join(' ');

    const subject = 'Request to Assign a Phone Number';
    const body = `Hi ${ownerName},\n\n${requesterName} has requested a phone number assignment in your Saleshandy Dialer workspace.\n\nWithout an assigned phone number, they are unable to make or receive calls through Saleshandy Dialer.\n\nAs the account owner, you can assign a phone number to ${requesterName} from the Phone Number Management section in your workspace settings.\n\nIf you have any questions, feel free to reach out to our support team.\n\nThanks,\nSaleshandy Team`;

    contactAdmin(subject, body);
  };

  return (
    <div className="purchase-phone-number-banner-wrapper">
      <div className="purchase-phone-number-banner">
        <div className="purchase-phone-number-icon">
          <PurchasePhoneNumberIcon width={61} height={61} />
        </div>
        {canPurchase ? (
          <>
            <div className="purchase-phone-number-banner-desc">
              <h1>Buy a Number to Start Calling</h1>
              <p>
                Purchase a local or international number to start outbound calls
                with your prospects.
              </p>
            </div>
            <div className="purchase-phone-number-actions">
              <button
                type="button"
                className="learn-more-link"
                onClick={() =>
                  window.open(
                    supportUrls.dialerPurchaseNumberLearnMoreLink,
                    '_blank',
                  )
                }
              >
                Learn More
              </button>

              <button
                type="button"
                className="purchase-button"
                onClick={handlePurchaseClick}
              >
                Purchase Number
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="purchase-phone-number-banner-desc">
              <h1>No Phone Number Assigned</h1>
              <p>
                Please contact your account owner to get a number assigned or
                request a new one.
              </p>
            </div>
            <div className="purchase-phone-number-actions contact-admin-actions">
              <button
                type="button"
                className="purchase-button"
                onClick={handleContactOwner}
              >
                Contact Admin
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PurchasePhoneNumberBanner;
